import { api } from '../api';
import { WalletAssetList } from '../wallet/types';
import {
  ASSET_STATUS,
  FIAT_DEPOSIT_INIT,
  GET_VSD_BANKS
} from '../../constants/fiatDeposit';
import {
  assetStatusPayload,
  assetStatusResponse,
  DepositInitRequestType,
  DepositInitResponseType,
  GetBankVSDResponse
} from './types';

export const fiatDepositSlice = api.injectEndpoints({
  endpoints: (build) => ({
    assetStatus: build.query<assetStatusResponse, assetStatusPayload>({
      query: (data) => ({
        url: `${ASSET_STATUS}`,
        method: 'POST',
        body: data
      })
    }),
    depositInit: build.mutation<
      DepositInitResponseType,
      DepositInitRequestType
    >({
      query(data) {
        return {
          url: FIAT_DEPOSIT_INIT,
          method: 'POST',
          body: data
        };
      }
    }),
    getVSDBanks: build.query<GetBankVSDResponse, void>({
      query: () => `${GET_VSD_BANKS}`
    })
  }),
  overrideExisting: false
});

export const {
  useAssetStatusQuery,
  useLazyAssetStatusQuery,
  useDepositInitMutation,
  useGetVSDBanksQuery
} = fiatDepositSlice;
